module.exports = __webpack_public_path__ + "img/1ne.f9c5b20f.svg";